import { useCallback, useState } from "react";

import { useClient } from "../../hook/useClient";
import PageIntro from "../../components/ui/PageIntro";
import GroupsPanel from "./GroupsPanel";

/**
 * How the system's discussions are organised, and who each part is for.
 *
 * The head explains the one rule that matters -- access flows DOWN the tree
 * -- and counts what the panel below loaded (it reports the tree back), so
 * the numbers never disagree with the table.
 */
const GroupsPage = () => {
  const { clientId, canManage } = useClient();
  const [tree, setTree] = useState(null);
  const onGroupsChange = useCallback((list) => setTree(list), []);

  const subgroups = tree ? tree.filter((g) => g.depth > 0).length : null;
  const threads = tree ? tree.reduce((n, g) => n + (g.thread_count || 0), 0) : null;

  return (
    <>
      <PageIntro
        icon="tabler:folders"
        title="Guruhlar"
        readOnly={!canManage}
        chips={
          tree
            ? [
                { icon: "tabler:folder", label: `${tree.length} ta guruh` },
                { icon: "tabler:folders", label: `${subgroups} ta ichki guruh` },
                { icon: "tabler:messages", label: `${threads} ta muhokama` },
              ]
            : []
        }
      >
        Guruh muhokamalarni va ularni koʻra oladigan odamlarni saqlaydi. Kirish huquqi{" "}
        <b>pastga</b> oʻtadi: guruhga qoʻshilgan odam shu guruh va uning ichidagi barcha
        guruhlar muhokamalarini koʻradi, yuqoridagi yoki yonidagilarini esa koʻrmaydi. Butun
        tizimga kirish uchun odamni ildiz guruhga qoʻshing.
      </PageIntro>
      <GroupsPanel clientId={clientId} canEdit={canManage} onGroupsChange={onGroupsChange} />
    </>
  );
};

export default GroupsPage;
